export default "__VITE_ASSET__aIJADVww__"